/**
 * The Font slice's loaders, the entry points `processors/createFontProcessor.ts` calls: one
 * for a raw container's bytes, one for the section a path addresses in a parsed `.tres`. The
 * decode stays pure over a property bag.
 */
import { fontResourceFromBytes } from '../../formats/dynamicfont/fontBytes';
import { resourceFilePath } from '../../subResourcePath';
import { decodeFont } from './decode';
/**
 * The `FontResource` that `section`, loaded from `path`, decodes to. A scene's own inline
 * Font never comes here: `resolveInlineFontResource` resolves it synchronously, never
 * through the resource event bus.
 */
export async function buildFontResource(path, { file, type, properties }, loadFont) {
    return decodeFont(resourceFilePath(path), type, properties, file.extResources, file.subResources, loadFont);
}
/** A raw font container's bytes. Text at a container path is no font, so it throws. */
export function fontResourceFromContainer(path, data) {
    if (typeof data === 'string')
        throw new Error(`${path} is text, not font bytes`);
    return fontResourceFromBytes(path, data);
}
//# sourceMappingURL=loadFont.js.map